var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "UI_icon_dashboard_light",
    "data-name": "UI icon/dashboard/light",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17.37,
    viewBox: "0 0 20 17.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_223_Stroke_",
    "data-name": "Ellipse 223 (Stroke)",
    d: "M10,2A8,8,0,0,0,4.349,15.662a1,1,0,0,1-1.413,1.416,10,10,0,1,1,14.135-.007,1,1,0,1,1-1.414-1.414A8,8,0,0,0,10,2Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M3,8A3,3,0,1,1,4.293,2.292l2-2A1,1,0,1,1,7.707,1.707l-2,2A3,3,0,0,1,3,8ZM3,4A1,1,0,1,0,4,5,1,1,0,0,0,3,4Z",
    transform: "translate(7 5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.74dc20eecc8831377c73ebd9fc7044b1.svg";
export { ForwardRef as ReactComponent };